import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-film-line text-background-50 text-lg"></i>
                </span>
                <span className="font-heading font-bold text-lg text-background-50">
                  光影在线
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                免费电影在线观看平台，海量高清影片资源随时畅享，无需下载、无需注册，支持手机电脑多端播放。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/kehuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                热门分类
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/kehuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">科幻电影</Link>
                <Link to="/category/dongzuo" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动作电影</Link>
                <Link to="/category/xiju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧电影</Link>
                <Link to="/category/oumei" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">欧美电影</Link>
                <Link to="/category/donghua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动画电影</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                联系我们
              </h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-400">
                <p className="whitespace-nowrap">
                  <i className="ri-mail-line mr-2"></i>
                  contact@guangyingzx.com
                </p>
                <p className="whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>
                  400-888-8888
                </p>
                <p className="whitespace-nowrap">
                  <i className="ri-map-pin-line mr-2"></i>
                  北京市朝阳区光影大厦
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 光影在线 - 免费电影在线观看高清全集，保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}